<template>
    <main class="page page-dashboard">
        <div class="container">

            <PageHeader
                :title="$translate.text('general.profile.add')"
            />

            <form @submit.prevent="submitForm" method="POST">
                <h4>{{ t('general') }}</h4>

                <TextInput
                    id="name"
                    :value="profile.name"
                    name="name"
                    @change="profile.name = $event"
                    :label="$translate.text('clients.feeds.name')"
                    :required="true"
                />

                <Select
                    id="type"
                    :value="profile.type"
                    name="type"
                    @change="profile.type = $event"
                    :options="typeOptions"
                    :label="$translate.text('clients.feeds.type')"
                    :required="true"
                />

                <Select
                    id="layout"
                    :value="profile.layout"
                    name="comparePrices"
                    @change="profile.layout = $event"
                    :options="layoutOptions"
                    :label="$translate.text('clients.feeds.layout')"
                    :required="true"
                />

                <TextInput
                    v-if="profile.type !== 'FILE'"
                    id="host"
                    :value="profile.host"
                    name="host"
                    @change="profile.host = $event"
                    :label="$translate.text('clients.feeds.host')"
                    :required="true"
                />

                <YesNoInput
                    v-if="profile.type !== 'FILE'"
                    id="authenticationRequired"
                    :value="profile.authentication_required ? 'yes' : 'no'"
                    name="authenticationRequired"
                    @change="profile.authentication_required = $event === 'yes'"
                    :label="$translate.text('clients.feeds.authentication_required')"
                />

                <TextInput
                    v-if="profile.authentication_required === true"
                    id="authenticationUsername"
                    :value="profile.authentication_user"
                    name="authenticationUsername"
                    @change="profile.authentication_user = $event"
                    :label="$translate.text('clients.feeds.authentication_user')"
                    :required="profile.authentication_required === true"
                />

                <PasswordInput
                    v-if="profile.authentication_required === true"
                    id="authenticationPassword"
                    :value="profile.authentication_password"
                    name="authenticationPassword"
                    @change="profile.authentication_password = $event"
                    :label="$translate.text('clients.feeds.authentication_password')"
                    :required="profile.authentication_required === true"
                />

                <h4 v-if="profile.type === 'FTP'">{{ t('clients.feeds.ftp_settings') }}</h4>

                <TextInput
                    v-if="profile.type === 'FTP'"
                    id="path"
                    :value="profile.ftp_dir_path"
                    name="path"
                    @change="profile.ftp_dir_path = $event"
                    :label="$translate.text('clients.feeds.path')"
                    :required="profile.type === 'FTP'"
                />

                <TextInput
                    v-if="profile.type === 'FTP'"
                    id="fileName"
                    :value="profile.ftp_filename"
                    name="fileName"
                    @change="profile.ftp_filename = $event"
                    :label="$translate.text('clients.feeds.file_name')"
                    :required="profile.type === 'FTP'"
                />

                <h4 v-if="profile.type === 'FILE'">{{ t('clients.feeds.file_upload_settings') }}</h4>

                <UploadInput
                    v-if="profile.type === 'FILE'"
                    id="fileUpload"
                    :value="profile.file.name"
                    name="fileUpload"
                    @change="profile.file = $event"
                    :uploadPercentage ="uploadPercentage"
                    :label="$translate.text('clients.feeds.choose_file')"
                />

                <h4 v-if="profile.layout === 'XML'">{{ t('clients.feeds.xml_settings') }}</h4>

                <TextInput
                    v-if="profile.layout === 'XML'"
                    id="productNodeName"
                    :value="profile.xml_node"
                    name="productNodeName"
                    @change="profile.xml_node = $event"
                    :label="$translate.text('clients.feeds.product_node_name')"
                    :required="profile.layout === 'XML'"
                />

                <h4 v-if="profile.layout === 'CSV'">{{ t('clients.feeds.csv_settings') }}</h4>

                <Select
                    v-if="profile.layout === 'CSV'"
                    id="seperator"
                    :value="profile.csv_seperator"
                    name="seperator"
                    @change="profile.csv_seperator = $event"
                    :options="seperatorOptions"
                    :label="$translate.text('clients.feeds.seperator')"
                    :required="profile.layout === 'CSV'"
                />

                <Select
                    v-if="profile.layout === 'CSV'"
                    id="wordSeperator"
                    :value="profile.csv_word_seperator"
                    name="wordSeperator"
                    @change="profile.csv_word_seperator = $event"
                    :options="wordSeperatorOptions"
                    :label="$translate.text('clients.feeds.word_seperator')"
                    :required="profile.layout === 'CSV'"
                />

                <!-- <NumberInput
                    v-if="profile.layout === 'CSV'"
                    id="rowsToIgnore"
                    :value="profile.csv_rows_ignore"
                    name="rowsToIgnore"
                    @change="profile.csv_rows_ignore = $event"
                    :label="$translate.text('clients.feeds.rows_ignore')"
                /> -->

                <YesNoInput
                    v-if="profile.layout === 'CSV'"
                    id="firstRowsAreColumnNames"
                    :value="profile.csv_first_row_names ? 'yes' : 'no'"
                    name="firstRowsAreColumnNames"
                    @change="profile.csv_first_row_names = $event === 'yes'"
                    :label="$translate.text('clients.feeds.first_row_names')"
                />

                <h4>{{ t('clients.feeds.settings') }}</h4>

                <Select
                    id="notation"
                    :value="profile.price_decimal_delimiter"
                    name="notation"
                    @change="profile.price_decimal_delimiter = $event"
                    :options="notationOptions"
                    :label="$translate.text('clients.feeds.notation')"
                    :required="true"
                    :tooltip="true"
                    :tooltip_text="$translate.text('clients.notation.explanation')"
                />

                <FormSubmit
                    :routeAfterCancelLink="{ name: 'Admin Profiles' }"
                    :buttonLabel="submittingIsLoading ? $translate.text('general.save.saving') :  $translate.text('general.save')"
                    :disabled="submittingIsLoading"
                />
            </form>
        </div>
    </main>
</template>
<script>
import axios from 'axios';

import handleError from '@/helpers/error';

import PageHeader from '@/components/PageHeader/PageHeader';
import TextInput from '@/components/Inputs/TextInput';
import PasswordInput from '@/components/Inputs/PasswordInput';
import YesNoInput from '@/components/Inputs/YesNoInput';
import Select from '@/components/Inputs/Select';
import FormSubmit from '@/components/Forms/FormSubmit';
import UploadInput from '@/components/Inputs/UploadInput';

import { getHeaders, getToken } from '@/helpers/auth';

export default {
    name: 'ResellersProfileAdd',

    components: {
        UploadInput,
        PageHeader,
        TextInput,
        PasswordInput,
        YesNoInput,
        Select,
        FormSubmit,
    },

    data() {
        return {
            profile: {
                name: '',
                type: '',
                layout: '',
                host: '',
                authentication_required: false,
                authentication_user: '',
                authentication_password: '',

                file: {
                    name: '',
                },

                csv_seperator: '',
                csv_word_seperator: '',
                // csv_rows_ignore: 0,
                csv_first_row_names: false,

                xml_node: 'product',

                ftp_dir_path: '',
                ftp_filename: '',

                price_decimal_delimiter: null,
            },

            typeOptions: [
                { label: this.$translate.text('general.select_option'), value: null },
                { label: 'HTTP(S)', value: 'HTTP' },
                { label: 'FTP(S)', value: 'FTP' },
                { label: 'Upload File', value: 'FILE' },
            ],

            layoutOptions: [
                { label: this.$translate.text('general.select_option'), value: null },
                { label: 'XML', value: 'XML' },
                { label: 'CSV', value: 'CSV' },
            ],

            authenticationRequiredOptions: [
                { label: this.$translate.text('general.no'), value: false },
                { label: this.$translate.text('general.yes'), value: true },
            ],

            seperatorOptions: [
                { label: this.$translate.text('general.select_option'), value: null },
                { label: this.$translate.text('general.comma'), value: 'Comma' },
                { label: this.$translate.text('general.dotcomma'), value: 'Dotcomma' },
                { label: this.$translate.text('general.tab'), value: 'Tab' },
                { label: this.$translate.text('general.pipe'), value: 'Pipe' },
            ],

            wordSeperatorOptions: [
                { label: this.$translate.text('general.select_option'), value: null },
                { label: this.$translate.text('general.double.quote'), value: 'Double quote' },
                { label: this.$translate.text('general.single.quote'), value: 'Single quote' },
            ],

            notationOptions: [
                { label: this.$translate.text('general.select_option'), value: null, disabled: true },
                { label: this.$translate.text('general.comma'), value: ',' },
                { label: this.$translate.text('general.dot'), value: '.' },
            ],

            submittingIsLoading: false,

            uploadPercentage: 0,
        };
    },

    methods: {
        submitForm() {
            this.submittingIsLoading = true;

            const data = { ...this.profile };

            data.authentication_required = data.authentication_required ? 1 : 0;
            data.csv_first_row_names = data.csv_first_row_names ? 1 : 0;

            const headers = getHeaders(getToken());
            headers['Content-Type'] = 'multipart/form-data';

            // We don't use the parent_id here. FormData will convert it to an string triggering validation errors in the backend
            delete data.parent_id;

            const formdata = new FormData();
            Object.keys(data).forEach(key => {
                formdata.append(key, data[key]);
            });

            axios({
                method: 'POST',
                url: `${this.$API_URL}/api/profiles/resellers`,
                headers,
                data: formdata,
                // eslint-disable-next-line
                onUploadProgress: function (progressEvent) {
                    // eslint-disable-next-line
                    this.uploadPercentage = parseInt(Math.round((progressEvent.loaded / progressEvent.total) * 100));
                }.bind(this),
            })
                .then(() => {
                    this.submittingIsLoading = false;
                    this.$router.push({ name: 'Resellers Profiles' });
                    this.resetForm();
                })
                .catch((error) => {
                    this.submittingIsLoading = false;
                    handleError({
                        error,
                        message: this.$translate.text('alert.whoops'),
                    });
                });
        },

        resetForm() {
            this.profile = {
                name: '',
                type: '',
                layout: '',
                host: '',
                authentication_required: false,
                authentication_user: '',
                authentication_password: '',

                file: '',

                csv_seperator: '',
                csv_word_seperator: '',
                // csv_rows_ignore: 0,
                csv_first_row_names: false,

                xml_node: 'product',

                ftp_dir_path: '',
                ftp_filename: '',

                price_decimal_delimiter: null,
            };
        },
    },

    watch: {
        'profile.type': function (type) {
            if (type === 'FILE') {
                this.profile.authentication_required = false;
            }
        },
    },
};
</script>
<style lang="scss" scoped>
</style>
